import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BookCall from "../components/BookCall";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { FaUtensils, FaGem, FaFileInvoice, FaMicroscope, FaMicrochip } from "react-icons/fa";

export default function ProjectsPage() {
  return (
    <>
      <Navbar />

      {/* Banner Section */}
      <div
        className="text-white text-center d-flex align-items-center justify-content-center"
        style={{
          height: "60vh",
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/wwd.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          animation: "fadeIn 2s ease-in-out",
        }}
      >
        <div>
          <h1 className="display-4 fw-bold mb-3">Our Creations</h1>
          <p className="lead">
            Explore a diverse range of tailor-made digital projects designed to transform businesses
            and enable innovation.
          </p>
        </div>
      </div>

      {/* Projects Section */}
      <section className="py-5 bg-light" style={{ textAlign: "justify" }}>
        <div className="container">
          <div className="row gy-4">

            {/* Project 1 */}
            <div className="col-12">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <FaUtensils size={36} className="mb-3 text-primary" />
                  <h4 className="card-title">Restaurant Management System</h4>
                  <p className="card-text">
                    A comprehensive restaurant suite built to streamline end-to-end operations. It
                    features dynamic menu management, real-time table bookings, kitchen coordination,
                    billing automation, and customer order tracking. Perfect for dine-in, takeaway,
                    and delivery businesses looking to go digital.
                  </p>
                </div>
              </div>
            </div>

            {/* Project 2 */}
            <div className="col-12">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <FaGem size={36} className="mb-3 text-warning" />
                  <h4 className="card-title">Jewelry Shop Management System</h4>
                  <p className="card-text">
                    A robust solution built specifically for gold, silver, and diamond retailers.
                    Enables live inventory tracking, purity-based categorization, rate adjustment as
                    per market prices, billing, and customer relationship tracking. Integrated with
                    SMS/email alerts for personalized marketing.
                  </p>
                </div>
              </div>
            </div>

            {/* Project 3 */}
            <div className="col-12">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <FaFileInvoice size={36} className="mb-3 text-success" />
                  <h4 className="card-title">Custom Billing System</h4>
                  <p className="card-text">
                    A flexible, plug-and-play billing system designed for small to mid-sized
                    businesses including salons, retail stores, and clinics. Features include
                    product/service listings, invoice generation, multi-tax support, discount
                    management, and real-time reporting dashboards.
                  </p>
                </div>
              </div>
            </div>

            {/* Project 4 */}
            <div className="col-12">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <FaMicroscope size={36} className="mb-3 text-danger" />
                  <h4 className="card-title">Healthcare Research Publication Portal</h4>
                  <p className="card-text">
                    Designed for medical colleges and research institutions, this portal facilitates
                    online article submissions, double-blind peer reviews, editorial workflows, and
                    research dissemination. Built with security and integrity to support academic
                    excellence in the medical research field.
                  </p>
                </div>
              </div>
            </div>

            {/* Project 5 */}
            <div className="col-12">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <FaMicrochip size={36} className="mb-3 text-secondary" />
                  <h4 className="card-title">Embedded & IoT Projects</h4>
                  <p className="card-text">
                    From smart homes to industrial IoT, our embedded systems leverage platforms like
                    Arduino, Raspberry Pi, and ESP32. We've built automation solutions, energy
                    monitoring tools, security systems, and robotic systems. Ideal for both
                    commercial deployment and academic showcases.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <BookCall />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
